import { Component, OnInit } from '@angular/core';
import { ServiceDashboardService } from '../service-dashboard.service';
import { SoftwareServices } from '../../../software-services/software-services.enum';

@Component({
    selector: 'landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  public get client() {
    return this.dashboardService.client;
  }

  public get website() {
    return this.dashboardService.website;
  }

  public get softwareServices() {
    return this.dashboardService.softwareServices;
  }

  public get websiteService() {
    let websiteService = this.dashboardService.softwareServices?.find(service => {
      return service.tag === SoftwareServices.websiteService;
    });
    
    if (websiteService) {
      websiteService.isEnabled = this.client.isWebsiteEnabled && !this.client.isSoftwareServiceRenewalDue;
    }

    return websiteService;
  }

  public get seoService() {
    let seoService = this.dashboardService.softwareServices?.find(service => {
      return service.tag === SoftwareServices.seoService;
    });
    
    if (seoService) {
      seoService.isEnabled = this.client.isSeoEnabled && !this.client.isSoftwareServiceRenewalDue;
    }

    return seoService;
  }

  public get smmService() {
    let smmService = this.dashboardService.softwareServices?.find(service => {
      return service.tag === SoftwareServices.smmService;
    });
    
    if (smmService) {
      smmService.isEnabled = this.client.isSmmEnabled && !this.client.isSoftwareServiceRenewalDue;
    }
    
    return smmService;
  }

  constructor(public dashboardService: ServiceDashboardService) { 
  }

  ngOnInit(): void {
  }
}